export default {
  'customers.title': 'Customers',
  'customer.menuTitle': 'Customers',
};
